import React from 'react'
import { graphql, HeadFC } from 'gatsby'

import Layout from '@src/components/Layout'
import ArticleList from '@src/components/ArticleList'
import SeriesSummary from '@src/components/SeriesSummary'
import Seo from '@src/components/Seo'
import CategoryTitle from '@src/components/CategoryTitle'
import { Article } from '@models/Article'
import { Parent } from '@models/Parent'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type SeriesPageProps = {
  data: {
    allParent: {
      nodes: Parent[]
    }
    allEnglishParent: {
      nodes: Parent[]
    }
    allArticle: {
      nodes: Article[]
    }
    allEnglishArticle: {
      nodes: Article[]
    }
  }
}
const SeriesPage: React.FC<SeriesPageProps> = ({ data }) => {
  const { locale } = useTranslation()
  const parents =
    locale === 'en' ? data.allEnglishParent.nodes : data.allParent.nodes
  const articles =
    locale === 'en' ? data.allEnglishArticle.nodes : data.allArticle.nodes

  return (
    <Layout>
      <div className={style.titleContainer}>
        <CategoryTitle title="SERIES" subTitle="SPECIAL CONTENT" />
      </div>

      <section>
        {parents.map(parent => {
          const seriesArticles = articles
            .filter(
              article =>
                article.parentPage !== null &&
                article.parentPage.id === parent.pageId,
            )
            .slice(0, 3)

          return (
            <div
              key={parent.pageId}
              data-artisan={parent.pageId === 'artisan_special_column'}
              className={style.series}
            >
              <div className={style.listBox}>
                <SeriesSummary series={parent} />
                <ArticleList
                  articles={seriesArticles}
                  gtmClickType="series-list"
                />
              </div>
            </div>
          )
        })}
      </section>
    </Layout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <Seo pathName={location.pathname} title="SERIES" />
)

export default SeriesPage

export const query = graphql`
  {
    allParent(filter: { category: { eq: "series" } }) {
      nodes {
        pageId
        path
        title
        category
        image {
          height
          url
          width
        }
        contents
        writer
        projectName
      }
    }
    allEnglishParent(filter: { category: { eq: "series" } }) {
      nodes {
        pageId
        path
        title
        category
        image {
          height
          url
          width
        }
        contents
        writer
        projectName
      }
    }
    allArticle(
      filter: { data: { category: { eq: "series" } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
    allEnglishArticle(
      filter: { data: { category: { eq: "series" } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
  }
`
